const ICON = '/favicon.ico';

let permissionGranted = false;

export async function requestNotificationPermission() {
    if (!('Notification' in window)) return false;
    if (Notification.permission === 'granted') { permissionGranted = true; return true; }
    if (Notification.permission === 'denied') return false;
    const result = await Notification.requestPermission();
    permissionGranted = result === 'granted';
    return permissionGranted;
}

function send(title, body, opts = {}) {
    if (!('Notification' in window)) return;
    if (Notification.permission !== 'granted') return;
    // Only show when tab is hidden
    if (!document.hidden) return;
    try {
        new Notification(title, { body, icon: ICON, badge: ICON, silent: false, ...opts });
    } catch {}
}

const pushNotifications = {
    init: requestNotificationPermission,

    yourTurn(playerName) {
        send('🎲 Your Turn!', `${playerName || 'You'}, roll the dice now!`);
    },

    playerJoined(name) {
        send('👋 Player Joined', `${name} joined the game`);
    },

    playerLeft(name) {
        send('🚪 Player Left', `${name} left the game`);
    },

    gameStarted() {
        send('🎮 Game Started!', 'The Ludo game has begun. Good luck!');
    },

    youWon() {
        send('🏆 You Won!', 'Congratulations! You are the Ludo King!');
    },

    someoneWon(name) {
        send('🏆 Game Over', `${name} won the game!`);
    },

    rolledSix(name) {
        send('🎉 Six Rolled!', `${name || 'A player'} rolled a 6!`);
    },

    tokenKilled(killerName, victimName) {
        send('💀 Token Killed!', `${killerName} knocked out ${victimName}'s token!`);
    },

    tokenHome(name) {
        send('🏠 Token Home!', `${name || 'A player'} got a token home!`);
    },
};

export default pushNotifications;
